export default "__VITE_ASSET__DVtE0U07__"